import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

//Services
import { getTranslateByKey } from '@/main/services/utils';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';

//Types
import { IInfoConfirmProcess } from '../cardGrid/cardGrid';

//Components
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

//Styles
import * as S from './styles';
import { procurementApi } from '@/main/api';
import { ProcurementProcessStatusRequest } from '@/main/models/request';
import ContentReturnApproval from './contentReturnApproval/contentReturnApproval';
import { SpinnerLoading } from '@/main/components/shared/styles';
import { ManageStatusItemsResponse } from '@/main/models/response';

interface ModalConfirmProcess {
  infoConfirmProcess: IInfoConfirmProcess;
  closeModalConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  loadViewOrder: () => Promise<void>;
  handleUpdateQuoteCountStatus: () => void;
  handleUpdateQuoteGridStatus: (
    guid: string,
    newStatus: number,
    newStatusSupplierName: string
  ) => void;
  setResultDataManageStatus: (data: ManageStatusItemsResponse | null) => void;
}
function ModalConfirmProcess({
  infoConfirmProcess,
  closeModalConfirm,
  loadViewOrder,
  handleUpdateQuoteCountStatus,
  handleUpdateQuoteGridStatus,
  setResultDataManageStatus
}: ModalConfirmProcess) {
  const [content, setContent] = useState<ReasonTypeEnum>(ReasonTypeEnum.NotReason);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function onSubmitSave(confirm: boolean) {
    setIsLoading(true);
    switch (infoConfirmProcess.idReasonType) {
      case ReasonTypeEnum.Part:
        apiConfirmReasonReturn(infoConfirmProcess, confirm);
        break;
      case ReasonTypeEnum.ReturnApprovalProcess:
        apiReturnApprovalProcess(infoConfirmProcess, confirm);
        break;
      default:
        break;
    }
  }

  const procurementItems = {
    idProcurementStatusCompany:
      infoConfirmProcess.idProcurementStatusCompany || 0,
    guidProcurementSupplierItem: infoConfirmProcess.guidSupplierItem || ''
  };

  async function changeStatusReturnApi(
    request: ProcurementProcessStatusRequest
  ) {
    try {
      const responseApi = await procurementApi.processReturnStatus(request);
      if (responseApi.data.result) {
        const resData = responseApi.data.result;
        if (resData.orderNewStatusIdChanged) {
          handleUpdateQuoteCountStatus();
          handleUpdateQuoteGridStatus(
            infoConfirmProcess.guidProcurement || '',
            resData.orderNewStatusIdChanged,
            resData.orderNewStatusNameChanged
          );
        }
        setResultDataManageStatus(resData);
      }
      loadViewOrder();
    } catch (error) {
    } finally {
      setIsLoading(false);
      closeModalConfirm(false);
    }
  }

  function apiConfirmReasonReturn(prop: IInfoConfirmProcess, confirm: boolean) {
    const request: ProcurementProcessStatusRequest = {
      guidProcurement: prop.guidProcurement || '',
      confirm: confirm,
      guidProcurementSupplier: prop.guidProcurementSupplier || '',
      guidReason: prop.guidReason || null,
      reasonDescription: prop.reasonDescription || null,
      idProcurementStatusCompanyNext: 0,
      procurementSupplierItems: [procurementItems]
    };
    changeStatusReturnApi(request);
  }

  function apiReturnApprovalProcess(
    prop: IInfoConfirmProcess,
    confirm: boolean
  ) {
    const request: ProcurementProcessStatusRequest = {
      guidProcurement: prop.guidProcurement || '',
      confirm: confirm,
      guidProcurementSupplier: prop.guidProcurementSupplier || '',
      guidReason: prop.guidReason || null,
      reasonDescription: prop.reasonDescription || null,
      idProcurementStatusCompanyNext: 0,
      procurementSupplierItems: [procurementItems],
      unauthorizedReturnProcess: !confirm
    };
    changeStatusReturnApi(request);
  }

  const contentRender = {
    [ReasonTypeEnum.Part]: (
      <ContentReturnApproval infoConfirmProcess={infoConfirmProcess} />
    ),
    [ReasonTypeEnum.ReturnApprovalProcess]: (
      <ContentReturnApproval infoConfirmProcess={infoConfirmProcess} />
    ),
    // Notation: status that do not have a modal
    [ReasonTypeEnum.Cancel]: null,
    [ReasonTypeEnum.Blacklist]: null,
    [ReasonTypeEnum.NotQuote]: null,
    [ReasonTypeEnum.TransferredSupplier]: null,
    [ReasonTypeEnum.NotReason]: null
  };
  const titleRender = {
    [ReasonTypeEnum.Part]: getTranslateByKey('information.returnPartConfirm'),
    [ReasonTypeEnum.ReturnApprovalProcess]: getTranslateByKey(
      'information.returnPartApprovalConfirm'
    ),
    // Notation: status that do not have a modal
    [ReasonTypeEnum.Cancel]: null,
    [ReasonTypeEnum.Blacklist]: null,
    [ReasonTypeEnum.NotQuote]: null,
    [ReasonTypeEnum.TransferredSupplier]: null,
    [ReasonTypeEnum.NotReason]: null
  };
  useEffect(() => {
    switch (infoConfirmProcess.idReasonType) {
      case ReasonTypeEnum.Part:
        setContent(ReasonTypeEnum.Part);
        break;
      case ReasonTypeEnum.ReturnApprovalProcess:
        setContent(ReasonTypeEnum.ReturnApprovalProcess);
        break;

      default:
        setContent(ReasonTypeEnum.NotReason);
        break;
    }
  }, []);

  return (
    <S.Contant>
      {content && <Typography variant="h5">{titleRender[content]}</Typography>}
      {content && contentRender[content]}

      {isLoading ? (
        <SpinnerLoading />
      ) : (
        <S.ButtonGroup>
          <SecondaryButton
            id="id-modalConfirmProcess-button-no"
            onClick={() => onSubmitSave(false)}
            disabled={isLoading}>
            {getTranslateByKey('information.no')}
          </SecondaryButton>
          <SecondaryButton
            id="id-modalConfirmProcess-button-yes"
            onClick={() => onSubmitSave(true)}
            disabled={isLoading}>
            {getTranslateByKey('information.yes')}
          </SecondaryButton>
        </S.ButtonGroup>
      )}
    </S.Contant>
  );
}

export default ModalConfirmProcess;
